import React, { useState } from "react";
import "./BookRecommendation.css";
import axios from "axios";

const BookRecommendation = () => {
  const [messages, setMessages] = useState([
    {
      from: "ai",
      text: "Hi there. Share a book or author you liked — I’ll recommend a few related reads just for you.",
    },
  ]);
  const [input, setInput] = useState("");

  const handleSend = async () => {
    if (!input.trim()) return;

    const userMessage = { from: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");

    try {
      const res = await axios.post(
        "https://bookmatchup.onrender.com/api/ai/recommend",
        {
          prompt: input,
        }
      );

      const aiResponse = {
        from: "ai",
        text: res.data.response,
      };
      setMessages((prev) => [...prev, aiResponse]);
    } catch (err) {
      console.error("AI error:", err);
      setMessages((prev) => [
        ...prev,
        {
          from: "ai",
          text: "Sorry, something went wrong with the recommendation.",
        },
      ]);
    }
  };
  

  return (
    <div className="matchup-chat-container">
      <h2 className="matchup-chat-title">Your AI Book Matchmaker</h2>
      <p className="matchup-chat-tagline">
        Smart suggestions based on books and authors tailored to your taste.
      </p>
      <div className="matchup-chat-window">
        {messages.map((msg, i) => (
          <div key={i} className={`matchup-chat-bubble ${msg.from}`}>
            {msg.text}
          </div>
        ))}
      </div>

      <div className="matchup-chat-input">
        <input
          type="text"
          placeholder="Enter a book and/or author..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
        />
        <button onClick={handleSend}>Find Books</button>
      </div>
    </div>
  );
};

export default BookRecommendation;
